import {RefObject, useEffect, useRef} from "react";

export function useGlobalModule<Module>(moduleGetter: () => Module): RefObject<null | Module> {
    const moduleRef = useRef<Module | null>(null);

    function get() {
        if (moduleRef.current !== null) {
            return;
        }
        try {
            moduleRef.current = moduleGetter();
        } catch {}
    }

    get();

    useEffect(() => {
        get();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return moduleRef;
}
